import { Box } from '@mui/material';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../components/dashboard/Header';
import ModifyBookingContent from '../../components/dashboard/ModifyBookingContent';
import SideDrawer from '../../components/dashboard/SideDrawer';
  
const ModifyBookingPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen((open) => !open);
  const { bookingId } = useParams<{ bookingId: string }>();

  return (
    <Box sx={{ display: 'flex' }}>
      <Header onToggleSidebar={toggleSidebar} open={sidebarOpen} />
      <SideDrawer open={sidebarOpen} />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <ModifyBookingContent bookingId={bookingId!} />
      </Box>
    </Box>
  );
};

export default ModifyBookingPage; 